var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          title: "Categorías",
          breadcrumbs: _vm.breadcrumbs,
          dense: true,
          hiddenTab: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                !_vm.isCurrentDefaultSegment
                  ? _c(
                      "v-btn",
                      {
                        attrs: { outlined: "" },
                        on: { click: _vm.handleAddSuppliers },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("mdi-account-plus"),
                        ]),
                        _vm._v("Agregar proveedores"),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isCurrentDefaultSegment
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "mx-2",
                        attrs: { outlined: "" },
                        on: { click: _vm.openEditCategory },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("mdi-pencil"),
                        ]),
                        _vm._v("Editar"),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.$store?.state?.auth?.account?.options?.includes(
                  "rec_process_rules"
                )
                  ? _c(
                      "v-btn",
                      {
                        attrs: { color: "grey-900" },
                        on: {
                          click: function ($event) {
                            _vm.dialogRules = true
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("mdi-cog"),
                        ]),
                        _vm._v("Configurar reglas"),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        { staticClass: "px-0 mt-20", attrs: { cols: "12" } },
        [
          _vm.loading
            ? _c("skeleton-list")
            : [
                _c("SupplierList", {
                  attrs: {
                    "suppliers-list": _vm.suppliersList,
                    "show-category-column": false,
                    "empty-title": "Agrega proveedores a esta categoría",
                  },
                  on: {
                    delete: _vm.handleDelete,
                    add: _vm.handleAdd,
                    change: _vm.handleChange,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "empty-actions",
                      fn: function () {
                        return [
                          !_vm.isCurrentDefaultSegment
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { outlined: "" },
                                  on: { click: _vm.handleAddSuppliers },
                                },
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("mdi-account-plus"),
                                  ]),
                                  _vm._v("Agregar proveedores"),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
        ],
        2
      ),
      _c("SupplierDeleteCategoryModal", {
        attrs: { supplier: _vm.currentItem },
        on: { confirm: _vm.handleDeleteConfirm },
        model: {
          value: _vm.dialogDelete,
          callback: function ($$v) {
            _vm.dialogDelete = $$v
          },
          expression: "dialogDelete",
        },
      }),
      _c("SupplierCategoryModal", {
        attrs: {
          "action-type": _vm.actionType,
          supplier: _vm.currentItem,
          "categories-list": _vm.groupsList,
          loading: _vm.createCategoryLoading,
        },
        on: { confirm: _vm.handleCategoryConfirm },
        model: {
          value: _vm.dialogAddCategory,
          callback: function ($$v) {
            _vm.dialogAddCategory = $$v
          },
          expression: "dialogAddCategory",
        },
      }),
      _c("ConfigureRulesModal", {
        attrs: {
          "segment-id": _vm.$route.params.id,
          "rule-data": _vm.currentRuleData,
        },
        on: { saved: _vm.handleRulesSaved },
        model: {
          value: _vm.dialogRules,
          callback: function ($$v) {
            _vm.dialogRules = $$v
          },
          expression: "dialogRules",
        },
      }),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "650",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogEditCategory,
            callback: function ($$v) {
              _vm.dialogEditCategory = $$v
            },
            expression: "dialogEditCategory",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Editar categoría")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogEditCategory = false
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { size: "24" } }, [
                                    _vm._v("mdi-close"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                {
                  staticClass: "pb-4 pt-5 px-5",
                  staticStyle: { "max-height": "600px !important" },
                },
                [
                  _c(
                    "v-list",
                    { staticClass: "pa-0 transparent v-list-form-card" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "pb-1" },
                        [
                          _c("v-list-item-title", [_vm._v("Nombre")]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                  placeholder:
                                    "Escribe el nombre de la categoría",
                                },
                                model: {
                                  value: _vm.editableCategory.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editableCategory, "name", $$v)
                                  },
                                  expression: "editableCategory.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "py-1" },
                        [
                          _c("v-list-item-title", [_vm._v("Descripción")]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                  placeholder:
                                    "Escribe una descripción de la categoría",
                                },
                                model: {
                                  value: _vm.editableCategory.description,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editableCategory,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression: "editableCategory.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogEditCategory = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.savingCategory,
                        disabled: !_vm.editableCategory.name.trim(),
                      },
                      on: { click: _vm.saveCategory },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }